import * as React from 'react';
import { PdsIconZoomOut as PdsIconZoomOutElement } from '@principal/design-system-icons-web';
import {
  IconSize,
  ValidIconColor,
} from '../../../utils/icon-utilities';
import { createPdsReactComponent } from '../../../../../react/src/lib/create-pds-react-component';

interface IconProps {
  size?: IconSize;
  color?: ValidIconColor;
}

export const PdsIconZoomOut = createPdsReactComponent<IconProps>()({
  tagName: 'pds-icon-zoom-out',
  elementClass: PdsIconZoomOutElement,
  react: React,
});

